import React from 'react';
import './LoadIndicator.css';

const DialLogo = () => {
    return (
        <svg width="56" height="55" viewBox="0 0 56 55" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_100_1118)">
            <path d="M29.8309 0V18.3004C29.2398 18.1833 28.6267 18.1211 28.0009 18.1211C27.375 18.1211 26.762 18.1833 26.1709 18.3004V0H29.8309Z" strokeWidth="0"/>
            <path d="M40.2146 2.79266L33.2113 19.7004C32.2048 19.027 31.0611 18.542 29.8313 18.3005L36.8347 1.39268L40.2146 2.79266Z" strokeWidth="0"/>
            <path d="M48.7401 9.34784L35.8003 22.2881L35.7984 22.2862C35.114 21.2651 34.2338 20.3848 33.2108 19.7004L46.1525 6.76016L48.7401 9.34784Z" strokeWidth="0"/>
            <path d="M52.7078 15.2846L35.8023 22.2882C36.4757 23.2947 36.9589 24.4385 37.2023 25.6701L54.1077 18.6665L52.7078 15.2846Z" strokeWidth="0"/>
            <path d="M55.5018 25.6701H37.202C37.3191 26.2612 37.3813 26.8743 37.3813 27.5002C37.3813 28.1261 37.3191 28.7391 37.202 29.3302H55.5018V25.6701Z" strokeWidth="0"/>
            <path d="M54.1077 36.3336L37.2023 29.33C36.9589 30.5616 36.4757 31.7054 35.8023 32.7119L52.7078 39.7155L54.1077 36.3336Z" strokeWidth="0"/>
            <path d="M35.7984 32.7138C35.7984 32.7138 35.7985 32.7138 35.8003 32.7138L48.7401 45.654L46.1525 48.2417L33.2108 35.3015C34.2338 34.617 35.114 33.7368 35.7984 32.7156V32.7138Z" strokeWidth="0"/>
            <path d="M29.8313 36.6996C31.0611 36.4581 32.2048 35.9731 33.2113 35.2997L40.2146 52.2074L36.8347 53.6074L29.8313 36.6996V36.6996Z" strokeWidth="0"/>
            <path d="M28.0009 36.8789C28.6267 36.8789 29.2398 36.8167 29.8309 36.6996V55H26.1709V36.6996C26.762 36.8167 27.375 36.8789 28.0009 36.8789V36.8789Z" strokeWidth="0"/>
            <path d="M22.7892 35.2997C23.7957 35.9731 24.9394 36.4581 26.171 36.6996L19.1677 53.6074L15.7859 52.2074L22.7892 35.2997V35.2997Z" strokeWidth="0"/>
            <path d="M22.7891 35.2996L9.84934 48.2398L7.26172 45.6521L20.2015 32.7119C20.8859 33.7349 21.7662 34.6151 22.7891 35.2996V35.2996Z" strokeWidth="0"/>
            <path d="M1.89412 36.3336L18.7995 29.33C19.0429 30.5616 19.526 31.7054 20.1995 32.7119L3.29404 39.7155L1.89412 36.3336Z" strokeWidth="0"/>
            <path d="M0.5 25.6701H18.7998C18.6827 26.2612 18.6205 26.8743 18.6205 27.5002C18.6205 28.1261 18.6827 28.7391 18.7998 29.3302H0.5V25.6701Z" strokeWidth="0"/>
            <path d="M3.29404 15.2846L20.1995 22.2882C19.526 23.2947 19.0429 24.4385 18.7995 25.6701L1.89412 18.6665L3.29404 15.2846Z" strokeWidth="0"/>
            <path d="M9.84934 6.76016L22.7891 19.7004C21.7662 20.3848 20.8859 21.2651 20.2015 22.2881H20.1997L7.26172 9.34784L9.84934 6.76016Z" strokeWidth="0"/>
            <path d="M19.1677 1.39268L26.171 18.3005C24.9394 18.542 23.7957 19.027 22.7892 19.7004L15.7859 2.79266L19.1677 1.39268Z" strokeWidth="0"/>
            </g>
            <defs>
            <clipPath id="clip0_100_1118">
            <rect width="55" height="55" fill="white" transform="translate(0.5)"/>
            </clipPath>
            </defs>
        </svg>
    )
}

export interface LoadIndicatorProps {
  message?: string;
  className?: string;
}

const LoadIndicator: React.FC<LoadIndicatorProps> = (props) => {
  const { message, className=''} = props;
  return (
    <div className={`spinner ${className}`}>
      <DialLogo/>
      {message ? <div>{message}</div> : null}
    </div>
  );
};

export default LoadIndicator;
